<template>
  <div class="navbar">
    <div class="fx">
      <span  class="pl20">
        <app-link to="//h.quzao.com/" class="ft-big-title text-theme mr4">趣造</app-link>
        <span class="logo ft-small-title text-theme">帮助中心</span>
      </span>
      <div class="pl20 pr20 fx fx1">
        <zt-input class="search fx1" v-model="kw" placeholder="查找问题" @keyup.enter.native="onSubmit"></zt-input>
      <zt-button type="primary" icon="el-icon-search" @click="onSubmit"></zt-button>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@imgs/logo.png'
export default {
  components: {
    
  },
  props: {
    
  },
  data: () => ({
    kw: '',
    logo,
  }),
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    onSubmit() {
      this.$router.push({
        path: '/search',
        query: {
          kw: this.kw
        }
      })
    }
  },
  created() {
    
  },
}
</script>

<style lang="scss" scoped>
.navbar {
  padding: 10px 0;
  background-color: $white;
  .logo {
    width: 200px;
    text-align: center;
  }
  .zt-button {
    margin-left: 4px;
  }
}

</style>